export default class Interceptor {
    request(request) {
        return request
    }
    response(response) {
        return response
    }
}
